import { LayoutDashboard, UserPlus, Search } from "lucide-react";
import DashboardLayout from "@/components/layout/DashboardLayout";

const NAV_ITEMS = [
  { to: "/staff/dashboard", label: "Dashboard", icon: LayoutDashboard, testId: "staff-nav-dashboard" },
  { to: "/staff/appointments/new", label: "New Appointment", icon: UserPlus, testId: "staff-nav-new-appointment" },
  { to: "/staff/search", label: "Patient Search", icon: Search, testId: "staff-nav-search" },
];

export default function StaffLayout({ children }) {
  return (
    <DashboardLayout navItems={NAV_ITEMS} roleLabel="Receptionist">
      {children}
    </DashboardLayout>
  );
}
